export default "__VITE_ASSET__BWJO9nli__"